type SortDir = "" | "asc" | "desc";
type ActiveDir = "asc" | "desc";

export const getActiveSort = (sorting: {
  name: SortDir;
  rotationDate: SortDir;
  session: SortDir;
  teacher: SortDir;
}) => {
  const entries = Object.entries(sorting) as Array<
    ["name" | "rotationDate" | "session" | "teacher", SortDir]
  >;

  const active = entries.find(([, dir]) => dir !== "");
  if (!active) return null;

  const [key, dir] = active;
  return { key, dir: dir as ActiveDir };
};

const cmpString = (a: string, b: string, dir: Exclude<SortDir, "">) => {
  const av = (a ?? "").toLowerCase();
  const bv = (b ?? "").toLowerCase();
  const res = av.localeCompare(bv);
  return dir === "asc" ? res : -res;
};

const cmpDate = (
  a: string | Date | undefined,
  b: string | Date | undefined,
  dir: Exclude<SortDir, "">,
) => {
  const at = a ? +new Date(a) : 0;
  const bt = b ? +new Date(b) : 0;
  const res = at - bt;
  return dir === "asc" ? res : -res;
};

export const sortExplorations = (
  explorations: any[],
  sorting: {
    name: SortDir;
    rotationDate: SortDir;
    session: SortDir;
    teacher: SortDir;
  },
  data: {
    sessions: any[];
    rotations: any[];
    teachers: any[];
  },
) => {
  const active = getActiveSort(sorting);
  if (!active) return explorations;

  const sessionsById = new Map(data.sessions.map((s) => [s._id, s]));
  const rotationsById = new Map(data.rotations.map((r) => [r._id, r]));
  const teachersById = new Map(data.teachers.map((t) => [t._id, t]));

  const { key, dir } = active;

  const list = explorations.slice();

  list.sort((ea, eb) => {
    if (key === "name") {
      return cmpString(ea.name, eb.name, dir);
    }

    if (key === "session") {
      const sa = sessionsById.get(ea.session)?.name ?? "";
      const sb = sessionsById.get(eb.session)?.name ?? "";
      return cmpString(sa, sb, dir);
    }

    if (key === "teacher") {
      const ta = teachersById.get(ea.teacher)?.name ?? "";
      const tb = teachersById.get(eb.teacher)?.name ?? "";
      return cmpString(ta, tb, dir);
    }

    // rotationDate
    const raId = sessionsById.get(ea.session)?.rotation;
    const rbId = sessionsById.get(eb.session)?.rotation;
    const raDate = raId ? rotationsById.get(raId)?.date : undefined;
    const rbDate = rbId ? rotationsById.get(rbId)?.date : undefined;

    return cmpDate(raDate, rbDate, dir);
  });

  return list;
};
